@if (ppIsSelected()) {
  <button class="toggle-button" (click)="ppHandleDeselect.emit()" data-test="deselectAllButton">
    {{ ppDeselectText() | ppTranslate }}
  </button>
} @else {
  <button class="toggle-button" (click)="ppHandleSelect.emit()" data-test="selectAllButton">
    {{ ppSelectText() | ppTranslate }}
  </button>
}
